import { Skill } from "../types/data";

export default [
    {
        language: "TypeScript",
        icon: "faJs",
        technologies: [
            "Next.js",
            "Node.js",
            "Express.js"
        ]
    },
    {
        language: "Java",
        icon: "faJava",
        technologies: [
            "Kotlin",
            "Paper API"
        ]
    },
    {
        language: "Python",
        icon: "faPython",
        technologies: [
            "Flask"
        ]
    },
    {
        language: "SQL",
        icon: "faDatabase",
        technologies: [
            "MySQL",
            "SQLite"
        ]
    },
    {
        language: "HTML",
        icon: "faHtml5",
        technologies: []
    },
    {
        language: "CSS",
        icon: "faCss3Alt",
        technologies: [
            "CSS Modules",
            "Tailwind",
            "Bootstrap"
        ]
    }
] as Skill[];